import { useLanguages } from '../../../../hooks'

const UpcomingClassLanguage = ({ language, className = '' }) => {
  const { formattedWorldLanguages } = useLanguages()

  const languageInfo =
    typeof language === 'string'
      ? formattedWorldLanguages.find((languageInfo) => languageInfo.value === language)
      : language?.name
        ? { label: language.name }
        : ''

  return (
    <li
      className={`bg-[#FDFDFD] py-[4px] px-[8px] rounded-[8px] h-[24px] text-xs font-normal font-Inter text-[#F67443] ${className}`}
    >
      {languageInfo ? languageInfo.label : language}
    </li>
  )
}

export default UpcomingClassLanguage
